import PushModal from './PushModal';

export default PushModal;
